export type NotificationCategories =
  | 'Blogs'
  | 'Alerts'
  | 'Notifications'
  | 'StartAndEndTime';

export type NotificationType = 'mail' | 'inApp';

type NotificationProperties =
  | 'isAllEmailAlert'
  | 'isAllEmailBlog'
  | 'isAllEmailNotifications'
  | 'isAllEmailStartEnd'
  | 'isAllInAppAlert'
  | 'isAllInAppBlog'
  | 'isAllInAppNotifications'
  | 'isAllInAppStartEnd';

export const propertyMap: Record<
  NotificationType,
  Record<NotificationCategories, NotificationProperties>
> = {
  mail: {
    Alerts: 'isAllEmailAlert',
    Blogs: 'isAllEmailBlog',
    Notifications: 'isAllEmailNotifications',
    StartAndEndTime: 'isAllEmailStartEnd',
  },
  inApp: {
    Alerts: 'isAllInAppAlert',
    Blogs: 'isAllInAppBlog',
    Notifications: 'isAllInAppNotifications',
    StartAndEndTime: 'isAllInAppStartEnd',
  },
};
